angular.module('lingoda.loader', [])
.directive('lingLoader', function () {
    return {
        restrict:'A',
        scope: true,
        template: '<div class="spinner">Loading...</div>',
        link: function(scope, iElement) {
            iElement.addClass('page-loader');
        }
    }
})
.service('lingCmpLoaderService', function() {
    var queue = $([]);
    this.add = function(element) {
        queue = queue.add(element);
        return true;
    };
    this.remove = function(element) {
        queue = queue.not(element);
        return (queue.filter(':visible').length === 0);
    };
})
.directive('lingCmpLoader', ['$compile', '$timeout', '$parse', 'lingCmpLoaderService', function($compile, $timeout, $parse, lingCmpLoaderService) {
    return {
        restrict: 'CA',
        link: function(scope, element, attrs) {

            var size = attrs.size ? attrs.size : 'md',
                minHeight = (size === 'sm') ? 30 : 50,
                loaderHelper = $('<div class="ling-cmp-helper ling-cmp-helper-' + size + '">' + lingoda.messages.loading + '</div>'),
                timeoutID = null,
                disabled = false,
                load = function(v) {
                    if(disabled) return false;

                    var height = null;
                    $timeout.cancel(timeoutID);
                    scope.$emit('ling:cmp:loader:before', v);
                    if(v) {
                        if(element.outerHeight() < minHeight) {
                            height = minHeight;
                        } else {
                            height = element.outerHeight();
                        }
                        element.transition({
                            height: height
                        });
                        attrs.$addClass('ling-cmp-loading');
                        if(lingCmpLoaderService.add(element)) {
                        }
                        timeoutID = $timeout(function() {
                            scope.$emit('ling:cmp:loader:after', v);
                        }, 300);
                        /*$timeout(function() {*/
                            //loaderHelper.transition({
                                //marginTop: 0
                            //});
                            //element.transition({
                                //height: height
                            //}, function() {
                                //if(attrs.scrollToLoader && !isElementInViewport()) {
                                    //helper.scrollTo(loader);
                                //}

                                //scope.$emit('ling:cmp:loader:after', v);

                                //$timeout(function() {
                                    //if(recall) {
                                        //load(false, true);
                                    //}
                                //});
                            //});
                        /*});*/
                    } else if(v === false) {
                        $timeout(function() {
                            element.css('height', 'auto');
                            attrs.$removeClass('ling-cmp-loading');
                        });
                        timeoutID = $timeout(function() {
                            scope.$emit('ling:cmp:loader:after', v);
                            if(lingCmpLoaderService.remove(element)) {
                            }
                        }, 300);
/*                        $timeout(function() {*/
                            //height = element[0].scrollHeight - element.outerHeight();
                            //loaderHelper.transition({
                                //marginTop: -1 * height
                            //});
                            //element.transition({
                                //height: height
                            //}, function() {
                                //element.css('height', 'auto');
                                //attrs.$removeClass('ling-cmp-loading');

                                //scope.$emit('ling:cmp:loader:after', v);
                            //});
                        /*});*/
                    }
                };

            element.prepend(loaderHelper);

            if(attrs.name) {
            //Form
                if(!attrs.manualLoader) {
                    scope.$watch('formloader["' + attrs.name + '"]', load);
                }
            } else if(element.hasClass('remote-loader')) {
            //Remote loader
                attrs.$observe('lingCmpLoader', load);
            } else {
                scope.$watch(attrs.lingCmpLoader, load);
            }

            if(attrs.disabled) {
                scope.$watch(attrs.disabled, function(v) {
                    disabled = v;
                });
            }
        }
    }
}])
//Deprecated controller
.controller('RemoteLoaderController', function() {})
//TODO Sync form's behaviour with remote loader
.directive('remoteLoader', ['$compile', '$timeout', function ($compile, $timeout) {
    return {
        restrict:'A',
        scope: {
            url: '@remoteLoader',
            params: '@',
            autoLoad: '@',
            id: '@',
            model: '@',
            method: '@',
            change: '@'
        },
        link: function(scope, iElement, attrs) {
            iElement.addClass('remote-loader');

            if(!scope.$parent.remoteloader) {
                scope.$parent.remoteloader = {};
            }

            //Init
            $timeout(function() {
                scope.method = scope.method || 'GET';

                var autoLoad = angular.isDefined(scope.autoLoad) ? scope.$eval(scope.autoLoad) : null;
                if(autoLoad) {
                    remoteLoader();
                } else if (autoLoad === false) {
                    setLoader('main', true);
                } else {
                    scope.cached = true;
                }
            });

            //Sync params
            scope.$watch('params', function(v) {
                if(v) {
                    if(typeof v === 'object') {
                        scope._params = v;
                    } else {
                        scope._params = scope.$new().$eval(v);
                    }
                }
            });

            var setLoader = function(type, v) {
                    loaderQueue[type] = v;
                    if(
                        (type === 'main' && v) ||
                        (!loaderQueue.main && !v)
                    ) {
                        attrs.$set('lingCmpLoader', v);
                        if(scope.id) {
                            scope.$parent.remoteloader[scope.id] = v;
                        }
                    }
                },
                loaderQueue = {
                    main: false
                },
                currentRequest = null,
                load = function() {
                    if(currentRequest) {
                        currentRequest.abort();
                    }
                    currentRequest = $.ajax({
                        url: scope.url,
                        data: scope._params,
                        type: scope.method
                    }).done(function(resp) {
                        //html content
                        scope.cached = true;
                        scope.$parent.cached = true;
                        if(!scope.model) {
                            iElement.children(':not(:first)').remove();
                            iElement.append(resp);
                            $compile(iElement.children())(scope.$parent);
                        } else {
                            /* Catch backend error */
                            var result = null;
                            try {
                                result = (typeof resp === 'string') ? $.parseJSON(resp) : resp;
                            } catch(o) {
                                scope.$emit('mainMessages:add', {
                                    type: 'error',
                                    content: !lingoda.environment.prod ? o.message: 'There was an error processing your request. Please try again.'
                                });
                            }
                            /* redirectURL */
                            if(result && result.redirectURL) {
                                window.location = result.redirectURL;
                                return false;
                            }

                            scope.$parent[scope.model] = result;
                            if(angular.isDefined(scope.change)) {
                                scope.$parent.$eval(scope.change);
                                scope.$parent.$apply();
                            }
                        }
                        setLoader('main', false);
                        scope.$apply();
                    }).fail(function(xhr, textStatus) {
                    });
                },
                remoteLoader = function(e, data, options) {
                    if(e && e.name === 'remoteLoader:load:cache' && scope.cached) {
                        setLoader('main', false);
                        return true;
                    }

                    //Trigger by id
                    if(options && options.id) {
                        if(options.id !== scope.id) {
                            return false;
                        }
                    }
                    $timeout(function() {
                        setLoader('main', true);

                        if(angular.isDefined(data)) {
                            $.each(data, function(key, v) {
                                scope[key] = v;
                            });
                        }
                        $timeout(load);
                    });
                },
                idle = function() {
                    setLoader('main', true);
                },
                active = function() {
                    setLoader('main', false);
                };

            scope.$parent.$on('remoteLoader:load', remoteLoader);
            scope.$parent.$on('remoteLoader:load:cache', remoteLoader);
            scope.$parent.$on('remoteLoader:cache:clear', function() {
                scope.cached = false;
            });
            scope.$parent.$on('remoteLoader:idle', idle);
            scope.$parent.$on('remoteLoader:active', active);
        }
    }
}]);
